import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import axios from "axios";
import { FormattedHTMLMessage } from 'react-intl';
import QRCode from 'qrcode.react';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import Section from './Section.js'
import CustomSpinner from './CustomSpinner.js';
import CustomAlert from './CustomAlert.js';
import FlowProgressBar from './FlowProgressBar.js';
import Header from './Header.js';
import LeadInfo from './LeadInfo.js';

require(`../assets/${process.env.PAGE}/css/components/Payment.css`);

class Payment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            qrCodeUrl: null
        };
    }

    componentDidMount() {
        const ROOT_URL = process.env.API_URL;
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
        };

        axios.get(`${ROOT_URL}/leads/payment`, config)
            .then((response) => {
                this.setState({
                    qrCodeUrl: response.data.payment_url
                });
            });
    }

    render() {
        const { handleSubmit, submitting, error} = this.props;
        const { qrCodeUrl } = this.state;

        return (
            <Section className="intro_form">
                <div className="row">
                    <Header>
                        <FlowProgressBar />
                        <FormattedHTMLMessage id="app.step_payment" defaultMessage="<h4><b>Realizá el pago de la primera cuota</b></h4>" description="Payment info" />
                    </Header>
                    <div className='container no-gutters'>
                        <div className="pd-content-bottom col-sm-12 col-md-8 col-lg-8 col-md-offset-2 col-lg-offset-2 text-center">
                            <form onSubmit={handleSubmit(this.props.savePayment)} className="pvc-form">
                                {this.props.isLoading && <CustomSpinner message='Procesando el pago...' />}
                                {error && <CustomAlert bsStyle="danger" message={error} />}

                                <div className="payment-content">
                                    <div className="qr-code-container">
                                        <div className="qr-code-placeholder">
                                            {qrCodeUrl ? <QRCode value={qrCodeUrl} size={256} /> : <CustomSpinner />}
                                        </div>
                                    </div>

                                    <div className="payment-instructions">
                                        {qrCodeUrl && <h4><a href={qrCodeUrl}>Link Mercado Pago</a></h4>}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                        <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>
                                            Continuar
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

Payment = TopScrolleable(Payment);

Payment = reduxForm({
    form: 'Payment', // a unique name for this form
})(Payment);

Payment = LeadInfo(Payment);
Payment = withAuthControl(Payment);

export default Payment;



/** WEBPACK FOOTER **
 ** ./src/components/Payment.js
 **/